import { UsageTrackerContextCampaign } from '@csp/csp-common-analytics';
import { Maybe } from '@csp/csp-common-model';

const URCHIN_TRACKING_MODULE_PREFIX = 'utm_' as const;
const URCHIN_TRACKING_MODULE_PREFIX_LENGTH = URCHIN_TRACKING_MODULE_PREFIX.length;

const safeDecodeURIComponent = (encodedURIComponent: string): string => {
  try {
    return decodeURIComponent(encodedURIComponent.replace(/\+/g, ' '));
  } catch {
    return encodedURIComponent;
  }
};

const get = (search: string): Maybe<UsageTrackerContextCampaign> => {
  const searchParams = new URLSearchParams(search);
  const maybeCampaign: Record<string, string> = {};

  searchParams.forEach((value, key) => {
    if (key.includes(URCHIN_TRACKING_MODULE_PREFIX) && key.length > URCHIN_TRACKING_MODULE_PREFIX_LENGTH) {
      let utmParam = key.slice(URCHIN_TRACKING_MODULE_PREFIX_LENGTH);
      if (utmParam === 'campaign') {
        utmParam = 'name';
      }
      maybeCampaign[utmParam] = safeDecodeURIComponent(value);
    }
  });

  return UsageTrackerContextCampaign.isOfType(maybeCampaign) ? maybeCampaign : undefined;
};

export const UtmCampaign = {
  get,
};
